/**
 * The only script a legal page runs. A legal page is copy, not the globe, so it
 * draws nothing. It reveals the header (served hidden, for the home page's intro
 * to bring in), puts the contact email together and marks the brand link home,
 * so following it back to the home page stays within the visit and skips the
 * intro.
 */
import { revealEmails } from './page/email'
import { markHomeLinks } from './page/visit'

const top = document.getElementById('top')
if (top) {
  top.classList.add('on')
  /* the header's backdrop once the copy scrolls under it, as the home page does */
  function scrolled() {
    top!.classList.toggle('stuck', window.pageYOffset > 40)
  }
  scrolled()
  window.addEventListener('scroll', scrolled, { passive: true })
}

const brand = document.querySelector<HTMLAnchorElement>('.brand')
if (brand) markHomeLinks([brand])

revealEmails()
